import {i18n} from "@/plugins/i18n";


export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 90,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('label.title'),
        sortable: true,
        width: 150,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        width: 150,
        sortable: true,
        textAlign: 'center',
    },
]